import * as Config from '../config';
import React from 'react';
import PropTypes from 'prop-types';
import AriaModal from 'react-aria-modal';
import './library/modal/Modal.css';

// Catch Global Error
function ErrorModal({ error }) {
  console.log('Crash Before Loading', error);

  const report = () => {
    // Report and send to a custom outside Error Management
    (window.errorLogCrash) && window.errorLogCrash(error);
    window.location.reload();
  }

  return <AriaModal
    titleText="ErrorModal"
    focusDialog={true}
    mounted={true}
    verticallyCenter={true}
    underlayClickExits={false}
    escapeExits={false}
    underlayClass={`underlay has-entered ${Config.API_NAME}`}
    underlayStyle={{
      width: `100%`, height: window.innerHeight + ((1 - window[`window_zoom`]) * 1000),
      position: `relative`,
      background: `rgba(36, 36, 36, 0.8)`
    }}
    dialogStyle={{}}
  >
    <div tabIndex={0} className={`modal bpc flexColumn modal--animated has-entered`} style={{ textAlign: `center` }}>
      <div className="modal-body">
        <div className={`flexColumn modal-form-container`}>
          <div className={`flexColumn cta`} style={{marginTop: `-40%`, marginLeft: `-10%`}}>
            <div className={`flexColumn modalV2`} style={{}}>
              <div className={`flexColumn body`} style={{gap: 26}}>
                <div className={`title`}>Session Timeout</div>
                <div className={`description`}> Make sure only one session is open and try reloading the page.</div>
                <div className={`flexRow group-cta`} style={{}}>
                  <div className={`cta primary`} onClick={report}>Reload</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AriaModal>;
}

ErrorModal.propTypes = {
  error: PropTypes.any
}

export default ErrorModal;
